import { Nullable } from "@core/domain/types/nullable.type";
import { DateTime } from "luxon";

export class MedicalLeavePeriod {
    constructor(
        public readonly id: number | undefined,
        public readonly terminationId: number,
        public startDate: DateTime,
        public endDate: DateTime,
        public companySalaryPercentage: number,
        public projectImputablePercentage: number,
        public observations: Nullable<string> = null,
    ) {}
}

export class CreateMedicalLeavePeriod {
    constructor(
        public readonly terminationId: number,
        public readonly startDate: DateTime,
        public readonly endDate: DateTime,
        public readonly companySalaryPercentage: number,
        public readonly projectImputablePercentage: number,
        public readonly observations: Nullable<string> = null,
    ) {}
}

export class EditMedicalLeavePeriod {
    constructor(
        public readonly id: number,
        public readonly terminationId: number,
        public readonly startDate: DateTime,
        public readonly endDate: DateTime,
        public readonly companySalaryPercentage: number,
        public readonly projectImputablePercentage: number,
        public readonly observations: Nullable<string> = null,
    ) {}
}
